import { api } from '@services';

const generateType = (actionType = 'CUSTOM', reducer = 'ORGANISM/PRODUCTMANAGE') => `${reducer}/${actionType}`;

export const fetchAllList = () => {
	return async (dispatch, getState) => {
		const { productType } = getState().organism.productManage;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'fetchAll', values: { $list: res.info ?? [] } },
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'fetchAll', values: { $list: [] } },
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'fetchAll', values: { _list: status } },
			});
		};

		api.$product_fetch_all({ onOK, onFail, onStatus }, { type: productType });
	};
};

export const saveItem = () => {
	return async (dispatch, getState) => {
		const { addItem, productType } = getState().organism.productManage;
		const { item } = addItem;
		const { name, symbol, buyPrice, sellPrice, innerBuyPrice, innerSellPrice, orderNumber, isVisible, isHead } = item;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'addItem', values: { show: false } },
			});
			await dispatch(fetchAllList());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'addItem', values: { _add: status } },
			});
		};

		api.$product_save(
			{ onOK, onFail, onStatus },
			{
				type: productType,
				name,
				symbol,
				buyprice: Number(buyPrice),
				sellprice: Number(sellPrice),
				innerbuyprice: Number(innerBuyPrice),
				innersellprice: Number(innerSellPrice),
				orderNumber: Number(orderNumber),
				isVisible,
				isHead,
			},
		);
	};
};

export const visibleItem = () => {
	return async (dispatch, getState) => {
		const { visibleItem } = getState().organism.productManage;
		const { selectedItem } = visibleItem;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'visibleItem', values: { selectedItem: null } },
			});
			await dispatch(fetchAllList());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'visibleItem', values: { _visible: status } },
			});
		};

		api.$product_edit(
			{ onOK, onFail, onStatus },
			{
				id: selectedItem.ID,
				type: selectedItem.TYPE,
				name: selectedItem.NAME,
				symbol: selectedItem.SYMBOL,
				buyprice: selectedItem.BUYPRICE,
				sellprice: selectedItem.SELLPRICE,
				innerbuyprice: selectedItem.INNERBUYPRICE,
				innersellprice: selectedItem.INNERSELLPRICE,
				orderNumber: selectedItem.ORDERNUM,
				isVisible: selectedItem.ISVISIBLE === 'Y' ? 'N' : 'Y',
				isHead: selectedItem.ISHEAD,
			},
		);
	};
};

export const headItem = () => {
	return async (dispatch, getState) => {
		const { headItem } = getState().organism.productManage;
		const { selectedItem } = headItem;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'headItem', values: { selectedItem: null } },
			});
			await dispatch(fetchAllList());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'headItem', values: { _visible: status } },
			});
		};

		api.$product_edit(
			{ onOK, onFail, onStatus },
			{
				id: selectedItem.ID,
				type: selectedItem.TYPE,
				name: selectedItem.NAME,
				symbol: selectedItem.SYMBOL,
				buyprice: selectedItem.BUYPRICE,
				sellprice: selectedItem.SELLPRICE,
				innerbuyprice: selectedItem.INNERBUYPRICE,
				innersellprice: selectedItem.INNERSELLPRICE,
				orderNumber: selectedItem.ORDERNUM,
				isVisible: selectedItem.ISVISIBLE,
				isHead: selectedItem.ISHEAD === 'Y' ? 'N' : 'Y',
			},
		);
	};
};

export const deleteItem = () => {
	return async (dispatch, getState) => {
		const { deleteItem } = getState().organism.productManage;
		const { selectedItem } = deleteItem;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'deleteItem', values: { selectedItem: null } },
			});
			await dispatch(fetchAllList());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'deleteItem', values: { _delete: status } },
			});
		};

		api.$product_delete(
			{ onOK, onFail, onStatus },
			{
				id: selectedItem.ID,
			},
		);
	};
};

export const editItemSelect = (item = null) => {
	return async (dispatch, getState) => {
		if (!item) return;

		await dispatch({
			type: generateType('CUSTOM'),
			payload: {
				...getState().organism.productManage,
				editItem: {
					...getState().organism.productManage.editItem,
					selectedItem: item,
					item: {
						id: item.ID,
						name: item.NAME,
						symbol: item.SYMBOL,
						buyPrice: item.BUYPRICE,
						sellPrice: item.SELLPRICE,
						innerBuyPrice: item.INNERBUYPRICE,
						innerSellPrice: item.INNERSELLPRICE,
						orderNumber: item.ORDERNUM,
						isVisible: item.ISVISIBLE,
						isHead: item.ISHEAD,
					},
				},
			},
		});
	};
};

export const editItem = (needToVerify = false) => {
	return async (dispatch, getState) => {
		const { editItem, productType } = getState().organism.productManage;
		const { item } = editItem;
		const {
			id,
			name,
			symbol,
			buyPrice,
			sellPrice,
			innerBuyPrice,
			innerSellPrice,
			orderNumber,
			isVisible,
			isHead,
			otp,
		} = item;

		const onOK = async (res) => {
			if (!needToVerify || otp) {
				await dispatch({
					type: generateType('CLEAR'),
					payload: { scope: 'editItem', values: {} },
				});
				await dispatch(fetchAllList());
			} else {
				await dispatch({
					type: generateType('SET'),
					payload: { scope: 'editItem', values: { sendVerificationCode: true } },
				});
			}
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'editItem', values: { _edit: status } },
			});
		};
		api.$product_edit(
			{ onOK, onFail, onStatus, showOkMessage: true },
			{
				id,
				type: productType,
				name,
				symbol,
				buyprice: Number(buyPrice),
				sellprice: Number(sellPrice),
				innerbuyprice: Number(innerBuyPrice),
				innersellprice: Number(innerSellPrice),
				orderNumber: Number(orderNumber),
				isVisible,
				isHead,
				code: otp ? Number(otp) : null,
			},
		);
	};
};

export const fetchItemHistory = () => {
	return async (dispatch, getState) => {
		const { selectedItem, from, size } = getState().organism.productManage.fetchItemHistory;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: {
					scope: 'fetchItemHistory',
					values: { $list: res.info.data ?? [], total: res.info.count.COUNT ?? 0 },
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'fetchItemHistory', values: { $list: [], total: 0 } },
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('SET'),
				payload: { scope: 'fetchItemHistory', values: { _list: status } },
			});
		};

		api.$product_fetch_all_archive(
			{ onOK, onFail, onStatus },
			{ id: selectedItem?.ID || 0, from, to: from + size - 1 },
		);
	};
};
